import axios from "axios";
import { BASE_URL } from "@/service_urls";

const tfw = {
    getDashboardCountryCount: ({ customer_uid}) => axios.get(`${BASE_URL}/public/job_with_country/count?customer_uid=${customer_uid}&is_super_customer=true`),
    fetchTFWCandidateCount: ({ customer_id }) => axios.get(`${BASE_URL}/customer/${customer_id}/candidate/total_count/super_customer/public/`)
};
export default tfw;
